module.exports = __webpack_public_path__ + "static/media/PJHeadshot.0a5b440f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teampics/PJHeadshot.png
// module id = 163
// module chunks = 0